import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface BoUserManagementItemsPerPageDTO {
  items: number;
}

export class BoUserManagementItemsPerPage {
  readonly isBoUserManagementItemsPerPageBoUserManagementItemsPerPage: boolean = true;

  readonly items: number;

  static readonly constraints = {
    "items": {
      "minValue": 1,
    }
  }

  constructor(
  items: number
  ) {
    BoUserManagementItemsPerPage.validateItems(items);
    this.items = items;
  }

  static fromDTO(dto: BoUserManagementItemsPerPageDTO): BoUserManagementItemsPerPage {
    const items = getInt32(dto, "items", InvalidBoUserManagementItemsPerPageItemsError);
    return new BoUserManagementItemsPerPage(
      items
    );
  }

  toDTO(): BoUserManagementItemsPerPageDTO {
    const dto: BoUserManagementItemsPerPageDTO = {
        items: this.items
    };
    return dto;
  }
  private static validateItems = (items: number): void => {
    if(items < 1) {
      throw new InvalidBoUserManagementItemsPerPageItemsMinValueError(
        1,
        `Attribute items has value ${items}. Min value is 1.`
      );
    }
  }
  
}

BoUserManagementItemsPerPage.prototype.toString = function toString(): string {
  return `BoUserManagementItemsPerPage(items='${this.items}')`;
};

export class InvalidBoUserManagementItemsPerPageError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserManagementItemsPerPageError";
  }
}
export class InvalidBoUserManagementItemsPerPageItemsError extends InvalidBoUserManagementItemsPerPageError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserManagementItemsPerPageItemsError";
  }
}

export class InvalidBoUserManagementItemsPerPageItemsMinValueError extends InvalidBoUserManagementItemsPerPageItemsError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBoUserManagementItemsPerPageItemsMinValueError";
  }
}
